const Modal = require('./modal');
const download = require('../../lib/util/download');
const template = require('./data-editor.tpl').default;

module.exports = DomClass(template, function() {
	var _t = this;

	Modal.call(this);

	_t.filename = 'data.txt';

	on(this, 'open').then(function(p) {
		_t.data = p.data;
		_t.filename = p.filename

		if (p.readonly) {
			_t.classList.add('readonly');
			_t.saveLink.onclick = null;
			_t.__dom.data.readOnly = true;
		} else {
			_t.classList.remove('readonly');
			_t.saveLink.onclick = () => {
				on(_t, 'save').fire(_t.data);
			};
			_t.__dom.data.readOnly = false;
		}
	});

	this.downloadLink.onclick = function() {
		download({
			data: _t.data.replace(/\r\n/gm, "\n").replace(/\n/gm, "\r\n"),
			filename: _t.filename
		});
	};

	this.closeLink.onclick = () => {
		this.close();
	};

});
